<template>
  <div class="EngagementFinder">
    <div class="EngagementFinderContainer">
      <div class="header">
        <div class="searchPart">
          <div class="Title"></div>
          <div class="searchBtn">
            <div class="inpSearchDiv">
              <input
                @keyup.enter="Filter()"
                type="text"
                placeholder="Search a credential"
                class="inpSearch"
              />
              <i
                aria-hidden="true"
                @click="Filter()"
                class="v-icon searchIcon material-icons theme--light"
              >search</i>
            </div>
          </div>
        </div>
        <export-excel :fetch="exportFct">
          <button class="exportBtn">
            <div class="exportBtnBehavior">
              Export
              <img class="exportImg" src="@/assets/excel.svg" alt />
            </div>
          </button>
        </export-excel>
      </div>

      <div class="EFTable">
        <v-data-table
          :items="credentialsTable"
          @click:row="handleClick"
          :options.sync="PaginationCredentials"
          :items-per-page="6"
          @update:items-per-page="getItemPerPageCredentials"
          :server-items-length="options.Credentials.totalItems"
          :footer-props="{
                        itemsPerPageOptions: [6, 10], 
                    }"
        >
          <template v-slot:body="{items}">
            <tr class="tabHeader">
              <th v-for="header in headersCredentials" :key="header.text">
                <div class="headresContainer">{{ header.text }}</div>
              </th>
            </tr>
            <tr
              v-for="(item, index)  in items"
              v-bind:class="{ stripedTab : checkRow(index)}"
              :key="item.id"
              class="dataRows"
              @click="handleClick(item)"
            >
              <td>{{ item.title }}</td>
              <td>{{ item.range }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
    <transition name="fade">
      <div class="shadow" v-if="openPopUp" v-on:click="CloseopenPopUp()"></div>
    </transition>
    <transition name="fade">
      <v-row class="EFPopUpRow" v-if="openPopUp">
        <v-col cols="3" @click="CloseopenPopUp()"></v-col>
        <v-col cols="12" md="6" class="EFPopUpCol">
          <div class="rejectPopUp">
            <div class="EFPopUpColTitle">Change the range of {{ credentialClicked.title }}</div>
            <input type="text" v-model="credentialClicked.range" class="popUpInputs" />
            <div class="PopUpSecondSubTitle"></div>
            <div class="EFPopUpColFooter">
              <div class="EFPopUpColFooterBtns">
                <button class="btn Cancel" @click="CloseopenPopUp()">Cancel</button>
                <button class="btn save" @click="updateMetier()">Save</button>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </transition>
  </div>
</template>

<script>
import $ from "jquery";
import api from "../mixins/api";
import endPoints from "../mixins/endPoints";

export default {
  name: "EngagementFinder",
  mixins: [api, endPoints],

  data() {
    return {
      baseUrl: window.baseUrlEngagementFinder,
      openPopUp: false,
      credentialsTable: [],
      credentialClicked: null,

      objToExport: [],
      userMail: null,

      headersCredentials: [
        { text: "Title", align: "left", value: "range" },
        { text: "Range", value: "title" }
      ],
      Relaunches: "Relaunches",
      options: {
        Credentials: {
          top: 3,
          skip: 0,
          totalItems: 0
        }
      },
      PaginationCredentials: {}
    };
  },
  methods: {
    getExcelData() {
      return this.get(this.baseUrl + "/v1/Meiters");
    },
    async exportFct() {
      let res = await this.getExcelData();
      let objToExp = res.data.value;
      this.objToExport = [];
      for (let index = 0; index < objToExp.length; index++) {
        let obj = {
          Title: objToExp[index].title,
          Range: objToExp[index].range
        };
        this.objToExport.push(obj);
      }
      return this.objToExport;
    },

    checkRow(index) {
      if (index % 2 == 0) {
        return false;
      }
      return true;
    },

    handleClick(value) {
      this.credentialClicked = value;
      this.openPopUp = true;
    },
    CloseopenPopUp() {
      this.openPopUp = false;
    },

    getMetiers() {
      this.get(this.baseUrl + "/v1/Meiters")
        .then(res => {
          this.credentialsTable = res.data.value;
          this.options.Credentials.totalItems = res.data["@odata.count"];
        })
        .catch(err => {
          window.console.log(err);
        });
    },

    updateMetier() {
      var entity = this.credentialClicked;
      entity.range = Number(entity.range);
      this.patch(
        this.baseUrl + "/v1/Meiters(" + this.credentialClicked.id + ")",
        entity
      )
        .then(res => {
          this.getMetiers();
          window.console.log(res);
          this.openPopUp = false;
        })
        .catch(err => {
          window.console.log(err);
        });
    },

    getItemPerPageCredentials(val) {
      if (this.options.Credentials.top != val) {
        this.options.Credentials.top = val;
        this.getMetiers();
      }
    }
  },
  mounted() {
    $(".v-data-footer")
      .find(".v-data-footer__select")
      .addClass("dataFooterNone");
    this.userMail = localStorage.getItem("connectedUserEmail");
    this.getMetiers();
  },
  watch: {
    PaginationCredentials(newval) {
      if (newval) {
        this.options.Credentials.top = newval.itemsPerPage;
        this.options.Credentials.skip = newval.itemsPerPage * (newval.page - 1);
        this.getMetiers();
      }
    }
  }
};
</script>
<style  scoped>
.EngagementFinder {
  padding: 24px;
  background-color: #fafafa;
  width: 100%;
  height: 100vh;
  position: relative;
  border-right: 1px solid #e4e7eb;
  font-family: sans-serif;
}
.EngagementFinder .EngagementFinderContainer {
  border: 1px solid #e4e7eb;
  width: 100%;
  position: relative;
  background-color: white;
  height: 584px;
  padding: 18px;
}
.EngagementFinderContainer .header {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: yellow */
}
.EngagementFinderContainer .header .searchPart {
  width: 500px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.searchBtn {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.inpSearchDiv {
  position: relative;
}
.searchIcon {
  position: absolute;
  left: 13px;
  top: 6px;
  font-size: 21px !important;
  cursor: pointer;
}
.searchPart .inpSearch {
  outline: none;
  color: #66788a;
  line-height: 20px;
  padding: 8px 0;
  padding-left: 40px;
  width: 250px;
  height: 32px;
  background: #f5f6f7 0% 0% no-repeat padding-box;
  border: 1px solid #e4e7eb;
}
.searchPart .Title {
  font-weight: bold;
  font-size: 16px;
  color: #152935;
  font-family: sans-serif;
}
.exportBtn {
  background-color: white;
  outline: none;
  border: solid 1px #2e7d32;
  width: 117px;
  height: 40px;
  color: #152935;
}
.BoxCheck {
  width: 18px;
  height: 18px;
  border-radius: 1px;
  border: solid #1070ca 1px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkIcon {
  color: white !important;
  font-size: 21px !important;
}
.filtrePart {
  width: 217px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
}
.OneFilter {
  color: #425a70;
  font-family: sans-serif;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.firstFilter {
  width: 47px;
}
.secondFilter {
  width: 60px;
}
.thirdFilter {
  width: 86px;
}
.activeFiltre {
  background-color: #1070ca;
}
.EFTable {
  border: solid 1px #f3f3f3;
  margin-top: 15px;
}
.shadow {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: #00000039;
  /* transition: opacity .5s; */
}
.EFPopUpRow {
  position: absolute;
  height: 515px;
  width: 100%;
  top: 6%;
  left: 0;
  margin: 0 !important;
}
.EFPopUpCol {
  background-color: white;
  border-top: 4px solid #1070ca;
  position: relative;
  height: 100%;
  box-shadow: 0px 12px 24px #0000001a;
  scrollbar-color: red yellow;
  padding-top: 34px;
}
.EFPopUpColTitle {
  font-weight: bold;
  color: #5a6872;
  margin-top: 14px;
  font-size: 28px;
  font-family: sans-serif;
}
.EFPopUpRows {
  margin-top: 35px;
}
.PopUpSubTitle {
  font-weight: bold;
  font-family: sans-serif;
  color: #234361;
  font-size: 18px;
}
.PopUpSecondSubTitle {
  font-weight: bold;
  font-family: sans-serif;
  color: #152935;
  font-size: 14px;
}
.popUpDescription {
  margin-top: 10px;
  font-size: 12px;
  color: #c9c9c9;
  font-family: sans-serif;
}
.popUpInputs {
  position: relative;
  margin-top: 10px;
  height: 40px;
  border: 1px solid #e4e7eb;
  width: 98%;
  padding-left: 16px;
  color: #152935;
  font-family: sans-serif;
  display: flex;
  align-items: center;
}
.selectHead {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 16px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}
.popUpsTextArea {
  margin-top: 10px;
  height: 32px;
  width: 98%;
  padding: 16px;
  outline: none;
  height: 105px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e4e7eb;
  color: #152935;
  font-family: sans-serif;
}
.separate {
  width: 99%;
  height: 1px;
  background-color: #e4e7eb;
}
.optioncontains {
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 39px;
  background-color: white;
  width: 100%;
  max-height: 90px;
  overflow: hidden;
  overflow-y: scroll;
  border: #c4d4e8 solid 1px;
  border-top: none;
  z-index: 2;
  height: auto;
}
.optioncontains :hover {
  background-color: #c4d4e8;
}
.optioncontains .options {
  display: flex;
  height: 40px;
  padding-left: 35px;
  align-items: center;
}
.selectActive {
  border: #c4d4e8 solid 1px !important;
}
.options .titles {
  margin-left: 25px;
}
.EFPopUpColFooter {
  position: absolute;
  width: 100%;
  height: 70px;
  background-color: #fafafa;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
}
.EFPopUpColFooterBtns {
  display: flex;
  align-items: center;
  width: 200px;
  justify-content: flex-end;
}
.EFPopUpColFooterBtns .btn {
  width: 128px;
  height: 40px;
  outline: none;
  border: none;
  color: white;
  font-weight: bold;
  font-family: sans-serif;
}
.EFPopUpColFooterBtns .Cancel {
  background-color: transparent;
  color: #1070ca;
  font-weight: 100;
}

.EFPopUpColContainer {
  height: calc(100% - 56px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.clear {
  height: 10px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.v-data-table-header {
  background-color: #fafafa !important;
}
.exportImg {
  width: 20px;
}
.exportBtnBehavior {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.selectArrowDown {
  position: absolute;
  right: 10px;
}
.theme--light.v-data-table thead tr th {
  text-align: left !important;
}
.tabHeader {
  position: relative;
  height: 48px;
  background: #fafafa;
  border: 1px solid #dfe3e6;
  text-align: left;
}
.hoverTr {
  background-color: #c4d4e8 !important;
}
.stripedTab {
  background: #f5f6f7 !important;
  border: 1px solid #dfe3e6;
}
.v-data-table th {
  border-bottom: 1px solid #dfe3e6;
}
.filterImg {
  width: 10px;
}
.headresContainer {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 110px;
}
.inputFilterContainer {
  height: 32px;
  width: 100%;
  position: absolute;
  left: -16px;
  display: flex;
  align-items: center;
  bottom: -47px;
  width: 142px;
  z-index: 99;
}
.columnFilter {
  height: 32px;
  width: 100%;
  border: #267ad5 solid 1px;
  background: white;
  border-radius: 1px;
  display: flex;
  align-items: center;
}
.closeIcon {
  position: absolute;
  right: 5px;
  font-size: 18px;
  color: #bf0e08;
}
.arrowForSort {
  font-size: 19px;
  transition-duration: 0.5s;
  color: #657179;
}
.arrowForSortTranslate {
  transform: rotate(180deg);
  transition-duration: 0.5s;
}
.v-data-table td {
  font-family: sans-serif !important;
}
.closePopUpIcon {
  position: absolute;
  right: 14px;
  top: 7px;
  font-size: 17px;
  cursor: pointer;
}
.dataRows {
  cursor: pointer;
}
.dataRows:hover {
  background-color: rgba(219, 234, 247, 0.83) !important;
}
.dateIcon {
  color: #1070ca;
  position: absolute;
  left: 16px;
  cursor: pointer;
}

.insertedDatesMargin {
  margin-left: 34px;
  cursor: pointer;
}
.datePicker {
  display: none;
  position: absolute;
  top: 89%;
  left: 35px;
  z-index: 99;
}
.activeDatePicker {
  display: block !important;
}
.curs {
  cursor: pointer;
}
.headerDateIcon {
  color: #1070ca;
  position: absolute;
  left: 4px;
  cursor: pointer;
}
.headerInputDate {
  position: absolute;
  height: 100%;
  border: none;
  outline: none;
  top: 0;
  left: 34px;
  width: calc(100% - 35px);
}
.save {
  background-color: #1070ca;
}
</style>